import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdminPanelSettingsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"admin_panel_settings"}/>
}
